import React from 'react';
import { Provider } from 'react-redux';
import store from '../../redux/store';
import CartRhsContent from './CartRhsContent';

const CartRhs = (props) => {
  const { themeSettings } = props;
  const newProps = { ...props, ...(themeSettings || {}) };
  return (
    <Provider store={store}>
      <CartRhsContent {...newProps} />
    </Provider>
  );
};

export default CartRhs;
